import { Button, ModalWindow, Ref, TextInput, Text } from "@tblabs/truffle";
import { PasswordSanitizer } from "../Utils/PasswordSanitizer";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { Device } from "../Services/Device";


export class PasswordEditWindow extends ModalWindow
{
    constructor(device: Device)
    {
        super(`📝 ${device.Id} password editor`, true, true, true);
        this.MaxWidth(460);

        const sanitizedPassword = new Ref<string>("\"" + PasswordSanitizer.Sanitize(device.Password.value) + "\"");
        const password = new Ref<string>(device.Password.value)
        password.OnChange(v =>
        {
            sanitizedPassword.value = "\"" + PasswordSanitizer.Sanitize(v) + "\"";
        });

        this.content.Append(
            device.IsPrivate && new Text("Device is private").Color("red").Bold(),
            new Table([], [
                ["Current", new Text("\"" + device.Password.value + "\"")],
                ["New", new TextInput(password).Width(240)],
                ["Sanitized", new Text(sanitizedPassword).Bold()],
            ]).Class("uk-table uk-table-small uk-table-striped")
        );

        this.footer.Append(
            new Button("Save & Exit").Class("uk-button uk-button-primary")
                .OnClick(async (btn) =>
                {
                    btn.Label("Saving...");
                    const newPassword = PasswordSanitizer.Sanitize(password.value);
                    if (await device.SetPassword(newPassword))
                    {
                        device.Password.value = newPassword;
                        this.CloseWindow();
                    }
                    else
                    {
                        alert("Could not set new password :(");
                        btn.Label("Try to save again");
                    }
                }),
            new Button("Cancel").Class("uk-button uk-button-default").MarginLeft(8)
                .OnClick(() => this.CloseWindow()),
        );

        this.OpenWindow();
    }
}
